export const downloadContentPhotosConstants = {
    DOWNLOAD_CONTENT_PHOTOS_PENDING  : 'DOWNLOAD_CONTENT_PHOTOS_PENDING',
    DOWNLOAD_CONTENT_PHOTOS_FULFILLED: 'DOWNLOAD_CONTENT_PHOTOS_FULFILLED',
    DOWNLOAD_CONTENT_PHOTOS_REJECTED : 'DOWNLOAD_CONTENT_PHOTOS_REJECTED',
};
